import React, { useState } from 'react';
import { ChevronUp, ChevronDown, GripVertical, X, AlertTriangle } from 'lucide-react';
import { fuenteLabel } from '../mapa/PointCard';

const move = (list, from, to) => {
  if (to < 0 || to >= list.length || from === to) return list;
  const next = [...list];
  const [it] = next.splice(from, 1);
  next.splice(to, 0, it);
  return next;
};

// Orden manual: arrastrar (ordenador) o botones Subir/Bajar (también en móvil). Nunca reordena solo.
export const VisitasOrderList = ({ items, onChange }) => {
  const [dragIdx, setDragIdx] = useState(null);
  if (!items.length) {
    return <p className="text-sm text-slate-500 py-3" data-testid="visitas-empty">No hay inmuebles seleccionados. Añádelos desde el mapa o la lista.</p>;
  }
  return (
    <ol className="space-y-1.5" data-testid="visitas-order-list">
      {items.map((a, i) => {
        const sinCoords = a.lat == null || a.lng == null;
        return (
          <li
            key={a.id}
            draggable
            onDragStart={() => setDragIdx(i)}
            onDragOver={(e) => e.preventDefault()}
            onDrop={() => { if (dragIdx !== null) onChange(move(items, dragIdx, i)); setDragIdx(null); }}
            onDragEnd={() => setDragIdx(null)}
            className={`flex items-center gap-2 rounded-lg border px-2 py-2 bg-white transition-colors ${dragIdx === i ? 'opacity-50' : ''} ${sinCoords ? 'border-amber-300 bg-amber-50' : 'border-slate-200'}`}
            data-testid={`visita-item-${a.id}`}
          >
            <GripVertical className="w-4 h-4 text-slate-300 cursor-grab hidden sm:block shrink-0" />
            <span className="w-6 h-6 shrink-0 rounded-full bg-blue-600 text-white text-xs font-semibold flex items-center justify-center" data-testid={`visita-orden-${a.id}`}>{i + 1}</span>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-slate-900 truncate">{a.codigo_npl || 'Sin código'} · {a.direccion || 'Sin dirección'}</p>
              {sinCoords
                ? <p className="text-[11px] text-amber-700 flex items-center gap-1"><AlertTriangle className="w-3 h-3" /> Sin coordenadas válidas</p>
                : <p className="text-[11px] text-slate-400 truncate">{a.municipio || ''} · {fuenteLabel(a.fuente)}</p>}
            </div>
            <div className="flex items-center shrink-0">
              <button type="button" onClick={() => onChange(move(items, i, i - 1))} disabled={i === 0} className="p-1.5 text-slate-500 hover:text-slate-900 disabled:opacity-30" title="Subir" aria-label="Subir" data-testid={`visita-up-${a.id}`}><ChevronUp className="w-4 h-4" /></button>
              <button type="button" onClick={() => onChange(move(items, i, i + 1))} disabled={i === items.length - 1} className="p-1.5 text-slate-500 hover:text-slate-900 disabled:opacity-30" title="Bajar" aria-label="Bajar" data-testid={`visita-down-${a.id}`}><ChevronDown className="w-4 h-4" /></button>
              <button type="button" onClick={() => onChange(items.filter(x => x.id !== a.id))} className="p-1.5 text-slate-400 hover:text-red-600" title="Quitar" aria-label="Quitar" data-testid={`visita-remove-${a.id}`}><X className="w-4 h-4" /></button>
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default VisitasOrderList;
